import { render, staticRenderFns } from "./spinning.vue?vue&type=template&id=1f044bdf&scoped=true"
import script from "./spinning.ts?vue&type=script&lang=ts&external"
export * from "./spinning.ts?vue&type=script&lang=ts&external"
import style0 from "./spinning.less?vue&type=style&index=0&id=1f044bdf&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f044bdf",
  null
  
)

export default component.exports